import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { TelematicBox } from '../../../../shared/interfaces';
import { AppSettings } from '../../../../shared/models';
import { AbstractBasicDataApiService } from '../../abstract-basic-data-api.service';

@Injectable({
  providedIn: 'root'
})
export class TelematicBoxApiService extends AbstractBasicDataApiService<TelematicBox> {

  constructor(
    protected http: HttpClient
  ) {
    super(http, AppSettings.endpoints.basicinformation.vehicles.telematicBox);

  }
}
